/* eslint-disable */
import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdDashboard,
  MdPublic,
  MdAccountCircle,
  MdAddCircleOutline,
  MdDescription,
  MdLogout,
  MdLock,
  MdCategory,
  MdLocalFireDepartment,
  MdEmojiEvents,
} from 'react-icons/md';

// === Imports untuk komponen ===
import MainDashboard from 'views/admin/default';
import Leaderboard from "views/admin/leaderboard";

import MainDashboardKaryawan from 'views/admin/dashboard_karyawan';
import MainDashboardTeknisi from 'views/admin/dashboard_teknisi';
//  == Path Routing For Mastering  Admin ===
import DataTables from 'views/admin/category';

import Departemen from 'views/admin/departemen';

// ====== Karyawan Routing 

import Profile from 'views/karyawan/history_my_ticket';
import LaporanPenangananTiket from 'views/karyawan/laporan_penanganan_tiket';
import LaporanWaktuPenyelesaian from 'views/karyawan/laporan_waktu_penyelesaian';


import ManageUser from 'views/karyawan/manage_user';


import MyHistoryTicketTL from 'views/karyawan/history_my_ticket_tl';

import TicketTrackKaryawan from 'views/karyawan/ticket_track_karyawan';

import DataGlobal from 'views/karyawan/display_data_global';


import AdminTransaksi from 'views/admin/TicketTransaksional';

import TicketPenyelesaianTransaksional from 'views/admin/TicketPenyelesaianTransaksional';
// === Import Komponen Baru ===
import TicketApproval from './views/admin/TicketApproval/index.jsx';


import SignInCentered from 'views/auth/signIn';



const routes = [
  // Role Admin
  {
    name: 'Data Dashboard ',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdDashboard} w="20px" h="20px" color="inherit" />,
    component: <MainDashboard />,
    roles: ['admin'],
  },
  // Role teknisi
  {
    name: 'Data Dashboard  Teknisi',
    layout: '/admin',
    path: '/dashboard-teknisi',
    icon: <Icon as={MdDashboard} w="20px" h="20px" color="inherit" />,
    component: <MainDashboardTeknisi />,
    roles: ['teknisi'],
  },

  {
  name: "Leaderboard",
  layout: "/admin",
  path: "/leaderboard",
  icon: <Icon as={MdEmojiEvents} />,
  component: <Leaderboard />,
        roles: ['admin', 'teknisi'],
},
  // Role Karyawan
  {
    name: 'Data Dashboard ',
    layout: '/admin',
    path: '/dashboard_karyawan',
    icon: <Icon as={MdDashboard} w="20px" h="20px" color="inherit" />,
    component: <MainDashboardKaryawan />,
    roles: ['karyawan'],
  },


  {
  name: 'Master Data',
  icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
    collapse: true,
    roles: ['admin'],
      items: [
          {
            name: 'Kategori',
            layout: '/admin',
            path: '/kategori',
            icon: <Icon as={MdCategory} w="20px" h="20px" color="inherit" />,
            component: <DataTables />,
            roles: ['admin'],
          },
          {
            name: 'Departemen',
            layout: '/admin',
            path: '/departemen',
            icon: <Icon as={MdLocalFireDepartment} w="20px" h="20px" color="inherit" />,

            component: <Departemen />,
            roles: ['admin'],
          },

            {
            name: 'Manage User',
            layout: '/admin',
            icon: <Icon as={MdLocalFireDepartment} w="20px" h="20px" color="inherit" />,
            path: '/priority',
            component: <ManageUser />,
            roles: ['admin'],
          },

          // {
          //   name: 'Prioritas',
          //   layout: '/admin',
          //   icon: <Icon as={MdLocalFireDepartment} w="20px" h="20px" color="inherit" />,
          //   path: '/priority',
          //   component: <Profile />,
          //   roles: ['admin'],
          // },
          // {
          //   name: 'Status',
          //   layout: '/admin',
          //   icon: <Icon as={MdLocalFireDepartment} w="20px" h="20px" color="inherit" />,

          //   path: '/status',
          //   component: <Profile />,
          //   roles: ['admin'],
          // },
      ],
  },

    {
  name: 'Transaksi',
  icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
    collapse: true,
    roles: ['admin','teknisi','karyawan'],
      items: [
          {
            name: 'Data Global',
            layout: '/admin',
            path: '/data-global',
            icon: <Icon as={MdPublic} w="20px" h="20px" color="inherit" />,
            component: <DataGlobal />,
            roles: ['admin'],
          },
        
          {
            name: 'Data Tiket Saya',
            layout: '/admin',
            path: '/data-saya',
            icon: <Icon as={MdAccountCircle} w="20px" h="20px" color="inherit" />,
            component: <Profile />,
            roles: ['admin'],
          },


        {
          name: 'Data Tiket Sudah TL oleh saya',
          layout: '/admin',
          path: '/data-tiket-tl-saya',
          icon: <Icon as={MdAccountCircle} w="20px" h="20px" color="inherit" />,
          component: <MyHistoryTicketTL />,
          roles: ['admin', 'teknisi'],
        },

      {
        name: 'Data Tiket tindak lanjut saya',
        layout: '/admin',
        path: '/data-teknisi',
        icon: <Icon as={MdAccountCircle} w="20px" h="20px" color="inherit" />,
        component: <TicketTrackKaryawan />,
        roles: ['admin', 'teknisi'],
      },
        {
        name: 'Buat Data',
        layout: '/admin',
        path: '/buat-data',
        icon: <Icon as={MdAddCircleOutline} w="20px" h="20px" color="inherit" />,
        component: <AdminTransaksi />,
        roles: ['admin', 'karyawan'],
      },
      {
        name: 'Approval Tiket', // <-- Halaman Baru
        layout: '/admin',
        path: '/approval-tiket',
        icon: <Icon as={MdAddCircleOutline} w="20px" h="20px" color="inherit" />,
        component: <TicketApproval />,
        roles: ['admin'], // Khusus admin saja
      },
      ],
  },


  {
  name: 'Riwayat & Pencatatan',
  icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
    collapse: true,
    roles: ['admin','teknisi','karyawan'],
      items: [
            
      {
        name: 'Riwayat Ticket Saya',
        layout: '/admin',
        path: '/history-ticket-saya',
        icon: <Icon as={MdAccountCircle} w="20px" h="20px" color="inherit" />,
        component: <Profile />,
        roles: ['karyawan'],
      },
          
      {
        name: 'Dokumentasi',
        layout: '/admin',
        path: '/dokumentasi',
        icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
        component: <Profile />,
        roles: ['karyawan'],
      },
      ],
  },

    {
  name: 'Laporan',
  icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
    collapse: true,
    roles: ['admin'],
      items: [
            
      {
        name: 'Laporan Riwayat Penanganan Tiket',
        layout: '/admin',
        path: '/laporan-riwayat-tiket',
        icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
        component: <LaporanPenangananTiket />,
        roles: ['admin'],
      },
          
      {
        name: 'Laporan Waktu Penyelesaian',
        layout: '/admin',
        path: '/laporan-waktu-penyelesaian',
        icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
        component: <LaporanWaktuPenyelesaian />,
        roles: ['admin'],
      },

         
      // {
      //   name: 'Laporan Tiket Prioritas Tinggi',
      //   layout: '/admin',
      //   path: '/dokumentasi',
      //   icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
      //   component: <Profile />,
      //   roles: ['admin'],
      // },
      
      ],
  },
  
  {
  name: 'Reporting',
  icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
    collapse: true,
    roles: ['admin'],
      items: [
            
      {
        name: 'Riwayat Ticket Saya',
        layout: '/admin',
        path: '/history-ticket-saya',
        icon: <Icon as={MdAccountCircle} w="20px" h="20px" color="inherit" />,
        component: <Profile />,
        roles: ['karyawan'],
      },
          
      {
        name: 'Dokumentasi',
        layout: '/admin',
        path: '/dokumentasi',
        icon: <Icon as={MdDescription} w="20px" h="20px" color="inherit" />,
        component: <Profile />,
        roles: ['karyawan'],
      },
      ],
  },



  {
    name: 'Buat Data',
    layout: '/admin',
    path: '/form-penyelesaian/:ticketId',
    icon: <Icon as={MdAddCircleOutline} w="20px" h="20px" color="inherit" />,
    component: <TicketPenyelesaianTransaksional />,
    roles: ['admin', 'teknisi'],
    hidden: true,
  },
{
  name: 'Keluar',
  icon: <Icon as={MdLogout} w="20px" h="20px" color="inherit" />,
  roles: ['admin', 'teknisi', 'karyawan'],
  isLogout: true, // 🔥 TAMBAH INI
},
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
    hidden: true,
  },



];

export default routes;
